import React, { ChangeEvent, memo } from 'react';
import { Input } from 'antd';
import { InputProps } from 'antd/es/input';

interface Props extends InputProps {
  onChange?: (event: ChangeEvent<HTMLInputElement> | string) => void;
}

const NumberInput = memo<Props>((props) => {
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const reg = /^-?\d*(\.\d*)?$/;
    if ((!Number.isNaN(Number(value)) && reg.test(value)) || value === '' || value === '-') {
      props.onChange && props.onChange(value);
    }
  };

  return <Input {...props} onChange={onChange} />;
});

export default NumberInput;
